export default __webpack_public_path__ + "static/media/p-quote.598bb58b.jpg";